import $ from 'jquery';
import hideJobDisplayIfEmpty from "./hideJobDisplayIfEmpty";

let gettingResults = false;
const createJobOverview = (superFilter = '', mainFilter = '', subFilter = '', searchString = '', resultsStep = 0) => {
    if (document.querySelector('.ume-career-finder-results-ajax-results') && gettingResults === false) {
        gettingResults = true;
        const target = document.querySelector('.ume-career-finder-results-ajax-results');
        let excludeID = target.getAttribute('data-exclude');
        let howManyToLoad = target.getAttribute('data-load') * 1;
        let loadMoreButton = document.querySelector('.ume-career-finder-results-holder--load-more');
        let spinner = document.querySelector('.ume-career-finder-spinner');
        let spinnerButton = document.querySelector('.ume-career-finder-results-holder--load-more-spinner');
        const controlBoard = document.querySelector('.ume-career-finder-holder');
        const handleControlBoard = (cb, targetStatus) => {
            if(cb !== null){
                let searchInput = cb.querySelector('.ume-career-search-input');
                if(targetStatus === 'disable'){
                    cb.classList.add('ume-career-finder-holder__inactive');
                    cb.setAttribute('aria-disabled', 'true');

                    if (searchInput !== null){
                        searchInput.disabled = true;
                        searchInput.setAttribute('aria-disabled', 'true');
                    }
                    return 'disabled';
                }
                if(targetStatus === 'enable'){
                    cb.classList.remove('ume-career-finder-holder__inactive');
                    cb.setAttribute('aria-disabled', 'false');

                    if (searchInput !== null){
                        searchInput.disabled = false;
                        searchInput.setAttribute('aria-disabled', 'false');
                    }
                    return 'enabled';
                }
                return 'failed';
            }
            return null;
        }
        spinner.classList.remove('d-none');
        handleControlBoard(controlBoard, 'disable');
        let data = {
            nonce: wp_environment.ume_job_finder_nonce,
            action: 'job_filter',
            super: superFilter,
            main: mainFilter,
            sub: subFilter,
            search: searchString,
            step: resultsStep,
            exclude: excludeID,
            load: howManyToLoad,
        };
        $.post(wp_environment.ume_ajax_url, data, function (response) {

            if (response) {

                let splitted = response.split('splithere0DaolEERzz');

                //let cleanCounter = splitted[0].replace(/<[^>]*>?/gm, '');
                // let max = parseInt(cleanCounter.split('Freie Stellen')[0]);

                let posAttr = splitted[0].split('data-counter="')[1];
                let max = parseInt(posAttr.split('"')[0]);

                let newStep = resultsStep + 1
                let isThereStuffToLoad = newStep * howManyToLoad >= max ? false : true;
                loadMoreButton.classList.remove('disabled');
                loadMoreButton.setAttribute('aria-disabled', 'true');
                if (!isThereStuffToLoad) {
                    loadMoreButton.classList.add('disabled');
                    loadMoreButton.setAttribute('aria-disabled', 'true');

                }
                if (resultsStep > 0) {
                    spinner.classList.add('d-none');
                    if (spinnerButton !== null) {
                        spinnerButton.classList.add('d-none');
                    }
                    handleControlBoard(controlBoard, 'enable');

                    $('.ume-career-finder-results-ajax-results').append(splitted[1]);
                    hideJobDisplayIfEmpty();
                } else {
                    spinner.classList.add('d-none');
                    if (spinnerButton !== null) {
                        spinnerButton.classList.add('d-none');
                    }
                    handleControlBoard(controlBoard, 'enable');
                    $('.ume-career-finder-results-ajax-results').html(splitted[0]);
                    $('.ume-career-finder-results-ajax-results').append(splitted[1]);
                    hideJobDisplayIfEmpty();
                }
                gettingResults = false;
            }


        })


    }
}
export default createJobOverview;